<template>
    <div class="people-list page">
        <div class="page-header" v-if="!!structure">
            <h4>
                {{ structure.name }} ({{
                    !!structure.structure_type
                        ? structure.structure_type.name
                        : ''
                }})
            </h4>
        </div>
        <button class="btn btn-secondary" @click="back">
            <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
        </button>
        <div class="alert alert-warning" v-if="!people.length">
            No hay personas asociadas a la estructura
        </div>
        <div class="table-responsive" v-if="!!people.length">
            <table
                class="table table-sm table-bordered table-hover table-striped"
            >
                <thead class="thead-orange">
                    <tr>
                        <th>Nombre</th>
                        <th>Documento</th>
                        <th>Cargo</th>
                        <th>Teléfono</th>
                        <th>E-mail</th>
                        <th>ARL</th>
                        <th>Notas</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(person, index) in people" :key="index">
                        <td>{{ person.name }}</td>
                        <td>{{ person.document }}</td>
                        <td>{{ person.position }}</td>
                        <td>{{ person.phone }}</td>
                        <td>{{ person.email }}</td>
                        <td>{{ !!person.arl ? person.arl.name : '' }}</td>
                        <td>{{ person.notes }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import structureRepository from '../../../repositories/structures.repository'
export default {
    props: ['structureId'],
    data() {
        return {
            structure: '',
            isAdminClient: false,
        }
    },
    methods: {
        loadStructure() {
            const sr = Object.assign({}, structureRepository)
            sr.byId(this.structureId).then(data => {
                this.structure = data
            })
        },
        back() {
            if (this.isAdminClient) {
                this.$router.push({
                    name: 'listStructuresAdminClient',
                    params: { preselectedClientId: this.structure.client_id },
                })
            } else {
                this.$router.push({
                    name: 'listStructures',
                    params: { preselectedClientId: this.structure.client_id },
                })
            }
        },
    },
    computed: {
        people() {
            return !!this.structure && !!this.structure.people.length
                ? this.structure.people
                : []
        },
    },
    created() {
        this.loadStructure()
        this.isAdminClient =
            this.user.profile.slug === 'cliente-admin' ? true : false
    },
}
</script>
